import { MatchRunStatus } from '@nkr/enums/match-run-status';

export interface IMatchRun {
    id: number,
    userId: number,
    user: string,
    matchRunType: number,
    matchRunTypeDescription: string,
    status: MatchRunStatus,
    statusDescription: string,
    submittedDateTime: string,
    startedDateTime: string,
    completedDateTime: string,
    completionTime: string,
    userFirstName: string,
    userLastName: string,
    deepestChainDepth: string,
    nddOneWayCount: string,
    ddOneWaysConfigured: string,
    totalOneWays: string,
    chainStartCount: string,
    currentStage: string,
    scenario: string
}